// ** Redux Imports
import { Action } from 'redux'
import { ThunkDispatch } from '@reduxjs/toolkit'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GygLoyaltyHistoryType, GygLoyaltyHistoryStateType } from 'src/types/apps/gygLoyaltyHistoryTypes'

import { LOYALTY_HISTORY_SLICE_NAME, GET_LOYALTY_HISTORY_BY_USER_ID_ACTION } from './actions'
import type { AxiosInstance } from 'axios'

type AxiosMiddlewareExtras = {
  httpClient: AxiosInstance
}

// todo(jhudiel) - move to root
interface Redux {
  getState: () => any
  dispatch: ThunkDispatch<any, AxiosMiddlewareExtras, Action<string>>
  extra: AxiosMiddlewareExtras
}

interface LoyaltyHistoryResponse {
  data: GygLoyaltyHistoryType[]
}

export const getLoyaltyHistoryByUserId = createAsyncThunk<LoyaltyHistoryResponse, string, Redux>(
  GET_LOYALTY_HISTORY_BY_USER_ID_ACTION,
  async (userId: string, { extra }) => {
    const response = await extra.httpClient(`loyalty-history?userId=${userId}`)

    return response.data
  }
)

const initialState: GygLoyaltyHistoryStateType = {
  gygLoyaltyHistory: [],
  getLoyaltyHistoryPending: false
}

export const gygLoyaltyHistorySlice = createSlice({
  name: LOYALTY_HISTORY_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getLoyaltyHistoryByUserId.fulfilled, (state, action) => {
        state.getLoyaltyHistoryPending = false
        state.gygLoyaltyHistory = action.payload.data
      })
      .addCase(getLoyaltyHistoryByUserId.pending, state => {
        state.getLoyaltyHistoryPending = true
      })
      .addCase(getLoyaltyHistoryByUserId.rejected, state => {
        state.getLoyaltyHistoryPending = false
      })
  }
})

export default gygLoyaltyHistorySlice.reducer
